var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiffuseFading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2 14.8H19.8C19.19 14.8 18.605 15.0424 18.1737 15.4737C17.7423 15.905 17.5 16.4901 17.5 17.1V79.9C17.5 80.51 17.7423 81.0951 18.1737 81.5264C18.605 81.9577 19.19 82.2 19.8 82.2H38.7V85.2H61.3V82.2H80.2C80.81 82.2 81.395 81.9577 81.8263 81.5264C82.2577 81.0951 82.5 80.51 82.5 79.9V17.1C82.5 16.4901 82.2577 15.905 81.8263 15.4737C81.395 15.0424 80.81 14.8 80.2 14.8Z",
    fill: "#E5DBCA",
    stroke: "#E5DBCA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 76.6C69.8 77.4 57.6 69.7 55.3 57.9C55.0179 56.2486 54.884 54.5753 54.9 52.9C55.6 66.6 68.5 76.1 81.5 76.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.7C30.2 19.9 42.4 27.6 44.7 39.4C44.9821 41.0514 45.116 42.7247 45.1 44.4C44.4 30.7 31.5 21.2 18.5 20.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 46.4H27.7L31.9 52.2V46.4H34.1V56H32.2L27.7 49.8V56H25.5V46.4Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 56H35.6L39.1 46.4H41.6L45.1 56H42.7L42 54H38.5L37.9 56ZM39.1 52.2H41.4L40.3 48.8L39.1 52.2Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1 46.4001C50.576 46.3542 51.056 46.4228 51.5 46.6001C51.9134 46.6991 52.293 46.9062 52.6 47.2001C52.834 47.476 53.0353 47.778 53.2 48.1001C53.3143 48.4565 53.3815 48.8262 53.4 49.2001C53.4244 49.7609 53.2854 50.3167 53 50.8001C52.6972 51.3216 52.2441 51.7398 51.7 52.0001L52.6 53.1001C52.7381 53.4061 52.9638 53.6644 53.2486 53.8424C53.5333 54.0204 53.8644 54.11 54.2 54.1001L54 56.0001H52.8L52 55.7001L51.2 55.1001L50.6 54.2001L49.5 52.5001H48.7V56.0001H46.4V46.4001H50.1ZM48.7 50.6001H49.7C50.0566 50.6074 50.4064 50.5025 50.7 50.3001C50.8948 50.0404 51 49.7246 51 49.4001C51 49.0755 50.8948 48.7597 50.7 48.5001C50.4064 48.2976 50.0566 48.1927 49.7 48.2001H48.7V50.6001Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48.6L58.2 49.1C58.026 49.3803 57.8915 49.6831 57.8 50C57.531 50.7087 57.531 51.4913 57.8 52.2C57.9016 52.5833 58.1096 52.93 58.4 53.2L59.3 53.8L60.6 54L62 53.8L63 53.4L63.8 55.2C62.7988 55.871 61.602 56.1878 60.4 56.1C59.6894 56.0987 58.9825 55.9977 58.3 55.8C57.7006 55.5863 57.1547 55.2451 56.7 54.8C56.1937 54.3775 55.8132 53.824 55.6 53.2C55.0654 51.851 55.0654 50.349 55.6 49C55.8148 48.4304 56.1568 47.9174 56.6 47.5C57.0427 47.0878 57.5493 46.7501 58.1 46.5C58.7122 46.2949 59.3544 46.1935 60 46.2L61.3 46.4L62.4 46.8C62.7111 46.9327 62.9855 47.1385 63.2 47.4L63.8 48.1L62.1 49.4C61.8 49.1 61.6 48.8 61.3 48.7C60.8971 48.4967 60.4512 48.3938 60 48.4C59.6538 48.3558 59.3026 48.426 59 48.6Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7 49.0999C64.9499 48.524 65.3258 48.0114 65.8 47.5999C66.2283 47.1223 66.783 46.7757 67.4 46.5999C68.0337 46.3359 68.7135 46.2 69.4 46.2C70.0865 46.2 70.7663 46.3359 71.4 46.5999C72.017 46.7757 72.5717 47.1223 73 47.5999C73.4742 48.0114 73.8501 48.524 74.1 49.0999C74.3378 49.7414 74.4727 50.4164 74.5 51.0999C74.4835 51.8172 74.3483 52.5268 74.1 53.2C73.8275 53.7923 73.4555 54.3335 73 54.7999C72.5208 55.213 71.9812 55.5502 71.4 55.7999C70.0968 56.201 68.7032 56.201 67.4 55.7999C66.8188 55.5502 66.2792 55.213 65.8 54.7999C65.3237 54.351 64.9486 53.8055 64.7 53.2C64.4154 52.5727 64.2785 51.8884 64.3 51.2C64.2772 50.479 64.4137 49.762 64.7 49.0999ZM66.9 52.2999C67.003 52.6544 67.2125 52.9686 67.5 53.2L68.3 53.7999L69.4 54L70.5 53.7999L71.3 53.2C71.5875 52.9686 71.797 52.6544 71.9 52.2999C72.0235 51.9459 72.091 51.5748 72.1 51.2C72.0824 50.7933 72.0153 50.3903 71.9 50C71.5778 49.4083 71.0917 48.9221 70.5 48.5999L69.4 48.4L68.3 48.5999C67.7083 48.9221 67.2222 49.4083 66.9 50C66.7847 50.3903 66.7176 50.7933 66.7 51.2C66.709 51.5748 66.7765 51.9459 66.9 52.2999Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 22.1H39.9C39.2373 22.1 38.7 22.6372 38.7 23.3V27.04C38.7 27.7027 39.2373 28.24 39.9 28.24H60.2C60.8628 28.24 61.4 27.7027 61.4 27.04V23.3C61.4 22.6372 60.8628 22.1 60.2 22.1Z",
    fill: "#7FBF7F",
    stroke: "#7FBF7F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiffuseFading);
export default __webpack_public_path__ + "static/media/diffuse-fading.65b8e985269fdb3239a21b91dcc7c9f8.svg";
export { ForwardRef as ReactComponent };